import { useMsal } from '@azure/msal-react';

export default function useLogout(logoutType: 'redirect' | 'popup' = 'redirect') {
  const { instance } = useMsal();

  const logout = () => {
    switch (logoutType) {
      case 'redirect':
        return instance.logoutRedirect();
      case 'popup':
        return instance.logoutPopup();
      default:
        throw new Error('Unsupported MSAL logout type');
    }
  };

  return {
    logout,
  };
}
